export default [
  {
    path: '/app/site-blocks',
    name: 'SiteBlocks',
    component: () => import('@/views/Admin/SiteBlocks/Index.vue'),
    meta: {
      pageTitle: 'İçerik Blokları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_SITE_BLOCKS',
      action: 'read',
    },
  },
  {
    path: '/app/site-blocks/add',
    name: 'SiteBlockAdd',
    component: () => import('@/views/Admin/SiteBlocks/Form.vue'),
    meta: {
      pageTitle: 'İçerik Blokları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/site-blocks',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_SITE_BLOCKS',
      action: 'read',
    },
  },
  {
    path: '/app/site-blocks/edit/:id',
    name: 'SiteBlockEdit',
    component: () => import('@/views/Admin/SiteBlocks/Form.vue'),
    meta: {
      pageTitle: 'İçerik Blokları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/site-blocks',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_SITE_BLOCKS',
      action: 'read',
    },
  },
]
